/* Japonija.lt theme-level LT/EN toggle
 * Default server-rendered language: Lithuanian.
 * Clicking EN swaps recognized strings via this dictionary.
 */
(function () {
  'use strict';
  var KEY = 'japonija-lang';
  var DEFAULT = 'lt';

  var DICT = {
    // Nav
    'Pradžia': 'Home',
    'Parduotuvė': 'Shop',
    'Ritualai': 'Rituals',
    'Apie': 'About',
    'Apie mus': 'About us',
    'Kontaktai': 'Contact',

    // Footer
    'Visi produktai': 'All products',
    'Mūsų istorija': 'Our story',
    'Filosofija': 'Philosophy',
    'Ankstyva prieiga': 'Early access',
    'Pristatymas': 'Shipping',
    'Grąžinimas': 'Returns',
    'Privatumas': 'Privacy',
    'Pagalba': 'Help',
    'Brand’as': 'Brand',

    // CTAs & buttons
    'Prisijungti prie laukiančiųjų': 'Join the waitlist',
    'Prisijunk prie laukiančiųjų': 'Join the waitlist',
    'Prisijungti': 'Join',
    'Prisijunk': 'Join',
    'Atrask ritualus': 'Discover rituals',
    'Prenumeruoti': 'Subscribe',
    'Skaityti': 'Read',
    'Skaityti →': 'Read →',
    'Pirkti': 'Buy',
    'Pirkti →': 'Buy →',
    'Atrasti': 'Discover',
    'Atrasti →': 'Discover →',
    'Peržiūrėti visą asortimentą': 'Browse full collection',
    'Visi straipsniai': 'All articles',
    'Skaityti mūsų istoriją': 'Read our story',
    'Skaityti visą straipsnį': 'Read full article',
    'Grįžti į pradžią': 'Back to home',
    'Grįžti į straipsnius': 'Back to articles',
    'Į krepšelį': 'Add to cart',
    'Siųsti žinutę': 'Send message',
    'Peržiūrėti krepšelį': 'View cart',
    'Pereiti prie apmokėjimo': 'Checkout',
    'Tęsti naršymą': 'Continue browsing',
    'Sukurti paskyrą': 'Create account',
    'Atnaujinti': 'Update',
    'Aktyvuoti': 'Activate',
    'Įeiti': 'Enter',
    'Atsijungti': 'Sign out',
    'Rodyti daugiau': 'Show more',

    // Tags / kickers
    'Rytas': 'Morning',
    'Vakaras': 'Evening',
    'Mokslas': 'Science',
    'Matcha': 'Matcha',
    'Okinava': 'Okinawa',
    'Miegas': 'Sleep',
    'Ritualas': 'Ritual',
    'Probiotikai': 'Probiotics',
    'Žarnynas': 'Gut',
    'Ilgaamžiškumas': 'Longevity',
    'Gerovė': 'Wellness',
    'Įrankiai': 'Tools',
    'Netrukus': 'Coming soon',
    'Naujiena': 'New',
    'Akcija': 'Sale',
    'Išparduota': 'Sold out',
    'Neprieinama': 'Unavailable',

    // Breadcrumbs & page chrome
    'Pereiti prie turinio': 'Skip to content',
    'Paieška': 'Search',
    'Krepšelis': 'Cart',
    'Atidaryti krepšelį': 'Open cart',
    'Atidaryti meniu': 'Open menu',
    'Uždaryti meniu': 'Close menu',
    'Uždaryti': 'Close',
    'Ankstesnis': 'Previous',
    'Kitas': 'Next',
    'Kraunama': 'Loading',
    'Kalba': 'Language',
    'Atgal': 'Back',
    'Pirmyn': 'Forward',
    'Puslapiavimas': 'Pagination',

    // Collection / product
    'Kolekcija': 'Collection',
    'Rikiuoti': 'Sort',
    'Rekomenduojama': 'Featured',
    'Populiariausi': 'Best selling',
    'Kaina: mažiausia': 'Price: low to high',
    'Kaina: didžiausia': 'Price: high to low',
    'Pavadinimas: A-Z': 'Title: A-Z',
    'Pavadinimas: Z-A': 'Title: Z-A',
    'Naujausi': 'Newest',
    'Filtrai': 'Filters',
    'Išvalyti': 'Clear',
    'Taikyti': 'Apply',
    'Kaina': 'Price',
    'Kiekis': 'Quantity',
    'Sumažinti': 'Decrease',
    'Padidinti': 'Increase',
    'Pasidalinti': 'Share',
    'Aprašymas': 'Description',
    'Detalės': 'Details',
    'Prekės ženklas': 'Brand',
    'Prekės galerija': 'Product gallery',
    'Leisti vaizdo įrašą': 'Play video',
    'Pranešti, kai bus prieinama': 'Notify me when available',
    'Taip pat pamėgsite': 'You may also love',
    'Kiti straipsniai': 'More articles',

    // Cart
    'Tarpinė suma': 'Subtotal',
    'Pašalinti': 'Remove',
    'Užrašas užsakymui': 'Order note',
    'Mokesčiai ir pristatymas skaičiuojami apmokėjimo metu.': 'Taxes and shipping calculated at checkout.',
    'Krepšelis kol kas tuščias': 'Your cart is empty',
    'Kai mūsų produktai pasieks Japoniją.lt, jie pasirodys čia.': 'Once Japonija.lt products arrive, they will appear here.',
    'Ritualai dar ruošiami': 'Rituals in the making',
    'Mūsų kruopščiai atrinkti produktai dar keliauja iš Japonijos. Prisijunkite prie laukiančiųjų sąrašo, kad sužinotumėte pirmi.': 'Our hand-picked products are still on their journey from Japan. Join the waitlist to be the first to know.',

    // 404
    'Puslapis nerastas': 'Page not found',
    'Atrodo, kad šis kelias nutolo nuo ritualo. Grįžkite į pagrindinį puslapį.': 'This path has drifted from the ritual. Return home to start again.',

    // Contact
    'Netrukus Lietuvoje': 'Arriving soon in Lithuania',
    'Susisiekime': 'Let’s talk',
    'Vardas': 'Name',
    'El. paštas': 'Email',
    'Telefonas': 'Phone',
    'Tema': 'Subject',
    'Žinutė': 'Message',
    'Ačiū - gavome jūsų žinutę ir atsakysime netrukus.': 'Thank you - we received your message and will reply shortly.',
    'Mūsų kontaktai': 'Our contacts',
    'EL. PAŠTAS': 'EMAIL',
    'Dažniausi klausimai': 'Frequently asked questions',
    'DUK': 'FAQ',
    'Kada bus galima užsisakyti produktų?': 'When can I order products?',

    // Newsletter
    'Ko ieškote?': 'What are you looking for?',
    'Ieškoti': 'Search',
    'Nieko nerasta. Bandykite kitus raktinius žodžius.': 'Nothing found. Try a different keyword.',
    'Prisijunk prie ilgaamžiškumo bendruomenės': 'Join the longevity community',
    'Pirmi sužinokite apie naujus ritualus, straipsnius ir produktus iš Japonijos.': 'Be the first to receive new rituals, articles and products from Japan.',
    'Ačiū. Netrukus gausite laišką.': 'Thank you. Your welcome letter is on its way.',
    'Gerbiame jūsų privatumą. Atsisakyti galite bet kada.': 'We respect your privacy. Unsubscribe any time.',
    'Gerbiame jūsų privatumą. Atsisakyti galėsite bet kada.': 'We respect your privacy. Unsubscribe any time.',

    // Account
    'Prisijungimas': 'Sign in',
    'Slaptažodis': 'Password',
    'Pamiršote slaptažodį?': 'Forgot your password?',
    'Neturite paskyros?': 'Don’t have an account?',
    'Paskyra': 'Account',
    'Užsakymai': 'Orders',
    'Profilis': 'Profile',
    'Adresai': 'Addresses',
    'Nuoroda nukopijuota. Įkelk į Instagram.': 'Link copied. Paste into Instagram.',

    // Blog
    'Autorius: ': 'By ',

    // Announcement bar
    'Ankstyva prieiga · −10% pirmam užsakymui': 'Early access · −10% off your first order',
    'Sukurta šeimos ilgesniam, ramesniam gyvenimui': 'Crafted for a longer, calmer family life',

    // Trust bar
    'Greitas pristatymas': 'Fast shipping',
    '1-3 d. Lietuvoje, nemokamai nuo 40 €.': '1-3 days in Lithuania, free over €40.',
    'Ceremoninė kokybė': 'Ceremonial quality',
    'Kruopščiai atrinkta iš Japonijos.': 'Hand-picked from Japan.',
    'Saugus mokėjimas': 'Secure payment',
    'SSL šifravimas, visi pagrindiniai būdai.': 'SSL encryption, all major methods.',

    // Pillars
    'Trys vertybės, kurios persipina kiekviename rituale.': 'Three values woven into every ritual.',
    'Japonija.lt filosofija gimsta iš dviejų pasaulių - mokslo tikslumo ir japoniškos ramybės.': 'Japonija.lt philosophy is born from two worlds - the precision of science and the calm of Japan.',
    'Remiamės naujausiais tyrimais apie ilgaamžiškumą ir sveiką senėjimą.': 'Rooted in the latest research on longevity and healthy aging.',
    'Paprastumas': 'Simplicity',
    'Aiškūs kasdieniai žingsniai, kurie natūraliai įsilieja į jūsų ritmą.': 'Clear daily steps that naturally fit into your rhythm.',
    'Pagarba kūnui': 'Respect for the body',
    'Švelnios formulės, kurios tarnauja organizmui - o ne prieš jį.': 'Gentle formulas that work with the body - not against it.',

    // Featured collections
    'Atrasti': 'Discover',
    'Paruošta paleisti': 'Ready to launch',
    'Ceremoninė matcha': 'Ceremonial matcha',
    'Subalansuota umami, lygi energija ir L-teaninu praturtintas ramus fokusas.': 'Balanced umami, smooth energy and L-theanine-rich calm focus.',
    'Arbatos ceremonijos rinkinys': 'Tea ceremony set',
    'Bambukinis chasen, chashaku ir chawan - amatininkų gaminti įrankiai.': 'Bamboo chasen, chashaku and chawan - handcrafted tools.',

    // Quote
    'Japonijoje ilgaamžiškumas nėra sėkmė ar atsitiktinumas - tai kasdieniai ritualai. Mes juos priartiname.': 'In Japan, longevity is not luck or chance - it is a daily ritual. We bring it closer to you.',
    'Japonija.lt filosofija': 'Japonija.lt philosophy',

    // About us (image-with-text)
    'Deriname japoniškus ritualus ir šiuolaikinį mokslą': 'We blend Japanese rituals with modern science',
    'Japonija.lt gimė iš noro gyventi lėčiau, giliau ir sąmoningiau. Mus įkvepia japoniška ramybė, disciplina ir pagarba mažoms kasdienėms detalėms, nes būtent jos ilgainiui kuria geresnę savijautą ir gyvenimo kokybę.': 'Japonija.lt was born from a desire to live slower, deeper and more consciously. We are inspired by Japanese calm, discipline and respect for the small everyday details - because those are what shape a better life over time.',
    'Atrenkame tai, kas dera su mūsų filosofija:': 'We curate what aligns with our philosophy:',
    'Mokslas - tai, kas pagrįsta, patikrinta ir prasminga.': 'Science - what is grounded, proven and meaningful.',
    'Paprastumas - mažiau, bet kokybiškiau.': 'Simplicity - less, but better.',
    'Pagarba kūnui - švelnūs sprendimai kasdieniam balansui.': 'Respect for the body - gentle choices for everyday balance.',
    'Japonija.lt - tai būdas sugrįžti prie savęs per mažus, prasmingus ritualus.': 'Japonija.lt is a way to return to yourself through small, meaningful rituals.',

    // Ritual steps
    'Rytinis matcha ritualas keturiais žingsniais': 'A morning matcha ritual in four steps',
    'Trumpas, realistiškas kasdienis įprotis, kuris paverčia rytą sąmoninga pradžia.': 'A short, realistic daily habit that turns morning into a mindful start.',
    'Pradėk nuo kvėpavimo': 'Start with the breath',
    '30-60 s lėto iškvėpimo aktyvuoja parasimpatinę nervų sistemą.': '30-60 s of slow exhales activates the parasympathetic nervous system.',
    'Sąmoningi įrankiai': 'Mindful tools',
    'Chasen, chawan, chashaku - rituale svarbi tvarka ir lytėjimas.': 'Chasen, chawan, chashaku - order and touch matter in the ritual.',
    'Ideali 70-80 °C': 'Ideal 70-80 °C',
    'Per karštas vanduo suardo amino rūgštis ir kuria kartumą.': 'Water that is too hot breaks down amino acids and creates bitterness.',
    'Pirmo gurkšnio pauzė': 'A pause on the first sip',
    'Pastebėk spalvą, kvapą, tekstūrą. Mikromeditacija.': 'Notice the colour, scent and texture. A micro-meditation.',

    // Article list
    'Naujausi straipsniai iš ilgaamžiškumo pasaulio': 'The latest from the world of longevity',
    'Mokslas, ritualai ir japoniška gyvenimo filosofija - kiekvienas straipsnis padeda gyventi sąmoningiau.': 'Science, rituals and Japanese life philosophy - each piece helps you live more consciously.',
    'Rytinis matcha ritualas ramiam startui': 'Morning Matcha Ritual for a Calm, Grounded Start',
    'Kaip paruošti matcha taip, kad ji taptų sąmoningu kasdieniu įpročiu.': 'How to prepare matcha so it becomes a mindful daily habit.',
    'Matcha nėra tik gėrimas - tai kasdienis ritualas, kuriame biochemija, Zen disciplina ir holistinis kūno bei proto supratimas susilieja į ramų, sąmoningą rytą.': 'Matcha is more than green tea - it is a daily ritual where biochemistry, Zen discipline and a holistic understanding of body and mind meet in a calm, mindful morning.',
    'Ilgaamžiškumo mokslas: Okinavos paradoksas': 'The Science of Longevity: What Japanese Research Says',
    'Ką rodo Japonijos tyrimai apie hara hachi bu, ikigai ir integruotą judėjimą.': 'What Japanese research shows about hara hachi bu, ikigai and integrated movement.',
    'Kas leidžia okinaviečiams išlikti ne tik ilgaamžiams, bet ir sveikais, fiziškai aktyviais iki labai garbaus amžiaus? Atsakymas - ne vienoje taisyklėje, o visumoje.': 'What allows Okinawans to remain not only long-lived but also healthy and physically active into very old age? The answer is not one rule - it is a whole ecosystem.',
    'Tylos papročiai: kaip nuraminti protą vakare': 'Silent Habits: How to Calm Your Mind in the Evening',
    'Septyni vakaro ritualai, kurie perveda į gilesnį ir atstatantį miegą.': 'Seven evening rituals that lead to deeper, restorative sleep.',
    'Tylos papročiai - tai mažos, sąmoningos vakaro praktikos, kurios padeda protui nurimti, įžeminti mintis ir natūraliai pasiruošti giliam miegui.': 'Silent rituals are small, conscious evening practices that help calm the mind, ground thoughts and prepare the body for naturally deeper sleep.',
    'Probiotikų galia: žarnyno ir odos ryšys': 'The Power of Probiotics: The Gut-Skin Connection',
    'Žarnynas yra mūsų imuniteto ir odos sveikatos centras. Probiotikai, fermentuoti produktai ir subalansuota mityba kuria domino efektą visame organizme.': 'The gut is the center of our immune and skin health. Probiotics, fermented foods and a balanced diet create a domino effect across the body.',
    // Article subtitles (used by main-article page)
    'Tradicinė Okinavos dieta ir kasdieniai judesiai ilgesniam gyvenimui': 'Traditional Okinawan diet and daily movement for a longer life',
    'Paprasti vakaro ritualai, padedantys pereiti į gilesnį poilsį': 'Simple evening rituals to help you transition into deeper rest',
    'Kaip paruošti matcha taip, kad ji taptų sąmoningu kasdieniu įpročiu': 'How to prepare matcha so it becomes a mindful daily habit',
    'Kaip fermentuoti produktai ir papildai veikia imunitetą bei grožį': 'How fermented foods and supplements affect immunity and beauty',

    // Footer
    'Įkvėpta japoniškų ritualų. Padedame gyventi ramiau, sąmoningiau ir ilgiau.': 'Inspired by Japanese rituals. Helping you live calmer, more mindfully, and longer.',
    'Visos teisės saugomos.': 'All rights reserved.',
    'Įmonės kodas:': 'Company code:',
    'Susisiekite:': 'Contact:',

    // Newsletter LT body
    'Viena idėja per savaitę, kuri padeda gyventi ramiau.': 'One idea a week to help you live calmer.',
    'Japoniški ritualai, kasdieniai įpročiai ir mokslinės įžvalgos - tiesiai į jūsų dėžutę.': 'Japanese rituals, daily habits and scientific insights - straight to your inbox.',
    'Ilgaamžiškumo laiškai': 'Longevity letters',

    // Section eyebrows / kickers
    'Bendruomenė': 'Community',
    'Produktai · Netrukus': 'Products · Coming soon',
    'Pirmoji kolekcija jau pakeliui iš Japonijos.': 'Our first collection is on its way from Japan.',
    'Autentiška matcha ir kruopščiai atrinkti ritualai ilgaamžiškumui. Prieiga pirmiausia tiems, kurie renkasi sąmoningai.': 'Authentic matcha and hand-picked longevity rituals. Access first for those who choose consciously.',
    'Prisijungti prie ritualo': 'Join the ritual',
    'Atrasti daugiau': 'Discover more',

    // Misc
    'produktai': 'products',
    'produktas': 'product',
  };

  function getInitialLang() {
    try {
      var saved = localStorage.getItem(KEY);
      if (saved === 'lt' || saved === 'en') return saved;
    } catch (e) {}
    return DEFAULT;
  }

  function applyLang(lang) {
    var root = document.documentElement;
    root.setAttribute('data-lang', lang);
    root.setAttribute('lang', lang);
    try { localStorage.setItem(KEY, lang); } catch (e) {}

    // Attribute translations (placeholder, aria-label, alt, title)
    var attrMap = { placeholder: 'data-i18n-placeholder', 'aria-label': 'data-i18n-aria', alt: 'data-i18n-alt', title: 'data-i18n-title' };
    Object.keys(attrMap).forEach(function (attr) {
      var base = attrMap[attr];
      document.querySelectorAll('[' + base + '-lt]').forEach(function (el) {
        var v = el.getAttribute(base + '-' + lang);
        if (v) el.setAttribute(attr, v);
      });
    });

    // Dictionary pass on text nodes inside [data-auto-i18n] containers
    document.querySelectorAll('[data-auto-i18n]').forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        // Skip nodes inside explicit bilingual containers
        var p = node.parentElement;
        while (p && p !== scope) {
          if (p.hasAttribute && (p.hasAttribute('data-lang-lt') || p.hasAttribute('data-lang-en') || p.classList && p.classList.contains('bi'))) return;
          if (p.tagName === 'SCRIPT' || p.tagName === 'STYLE') return;
          p = p.parentElement;
        }
        var raw = (node.textContent || '');
        var trimmed = raw.trim();
        if (!trimmed) return;
        // Store original once
        if (!node._origLT) node._origLT = trimmed;
        var leading = raw.match(/^\s*/)[0];
        var trailing = raw.match(/\s*$/)[0];
        var replacement;
        if (lang === 'en' && DICT[node._origLT]) {
          replacement = DICT[node._origLT];
        } else {
          replacement = node._origLT;
        }
        node.textContent = leading + replacement + trailing;
      });
    });

    // Toggle button state
    document.querySelectorAll('[data-lang-btn]').forEach(function (btn) {
      var btnLang = btn.getAttribute('data-lang-btn');
      btn.setAttribute('aria-pressed', btnLang === lang ? 'true' : 'false');
    });
  }

  // Set html[data-lang] early
  var initial = getInitialLang();
  document.documentElement.setAttribute('data-lang', initial);
  document.documentElement.setAttribute('lang', initial);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyLang(initial); bind(); });
  } else {
    applyLang(initial); bind();
  }

  function bind() {
    document.querySelectorAll('[data-lang-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var newLang = btn.getAttribute('data-lang-btn');
        if (newLang) applyLang(newLang);
      });
    });
  }

  window.japonijaLang = { set: applyLang, get: function () { return document.documentElement.getAttribute('data-lang'); } };
})();
